/* eslint-disable react/prop-types */
import "./ShowUserInfo.css";
import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { Store } from "../Store/store";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { API_URL, unescapeHTML, custom_axios, custom_axios_post, kbnOptions } from "./Common";
import Slide from "@mui/material/Slide";
import styled from "@emotion/styled";
import TextField from "@mui/material/TextField";
import ContentEditable from "react-contenteditable";
import SendIcon from "@mui/icons-material/Send";
import DeleteIcon from "@mui/icons-material/Delete";
import SendAndArchiveIcon from "@mui/icons-material/SendAndArchive";
import CancelScheduleSendIcon from "@mui/icons-material/CancelScheduleSend";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import IconButton from "@mui/material/IconButton";
import AttachFile from "@mui/icons-material/AttachFile";
import Badge from "@mui/material/Badge";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useDropzone } from "react-dropzone";
import ShowCommon from "./ShowCommon";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MultiSelect } from "react-multi-select-component";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import ShowTimelinePreview from "./ShowTimelinePreview";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledDialogContent = styled(DialogContent)`
  padding: 0px;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-right: 20px;
`;
const StyledDialogTitle = styled(DialogTitle)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 5px 10px;
`;
const StyledButton = styled(Button)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
`;
const StyledMarginDiv = styled("div")`
  margin-right: 50px;
`;

const StyledFlexDiv = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
`;
const StyledFlexMainDiv = styled("div")`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: start;
`;

const StyledFlexTextDiv = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px;
`;

const StyledFileList = styled("div")`
  margin-left: 100px;
  padding: 5px;
  border: 3px solid #ccc;
  background-color: #f9f9f9;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
`;

const StyledFileListItem = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  margin-right: 5px;
  padding: 5px;
  background-color: white;
  border-radius: 4px;
  width: auto;
`;

const StyledFileLink = styled("a")`
  text-decoration: none;
  color: black;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

function ShowTimelinePost({
  open,
  timelineid,
  issend,
  fileno,
  name,
  kbn,
  title,
  message,
  sendflagcheck,
  iswebcheck,
  iscommentcheck,
  edithonbuid,
  ids,
  handleClose,
}) {
  const history = useHistory();

  const myRef = useRef(null);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error"); // デフォルトはエラー

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const showSnackbar = (message, severity = "error") => {
    setOpenCreateCommon(false);
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const [inputtext, setInputtext] = useState({ html: "本文を入力してください..." });
  const [isPlaceholder, setIsPlaceholder] = useState(true); //placeholder表示の状態

  const [charSize, setCharSize] = useState(0);

  const InputElRef = useRef(null);
  const inputTemplateRef = useRef(null);
  const [inputTemplateRefFileNum, setInputTemplateRefFileNum] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [fileNumError, setFileNumError] = useState(false);
  const [fileSizeError, setFileSizeError] = useState(false);

  const { getRootProps: getThumbnailDropProps, getInputProps: getThumbnailInputProps } = useDropzone({
    accept: "image/*", // 画像ファイルのみを受け付ける
    maxFiles: 1, // 最大ファイル数を1に制限
    onDrop: (acceptedFiles) => {
      // ドロップされたファイルの処理
      if (acceptedFiles && acceptedFiles.length > 0) {
        handleThumbnailChange({ target: { files: acceptedFiles } });
      }
    },
    // noClick: true, //クリックでエクスプローラーが開かないようにする
  });

  const { getRootProps, getInputProps, acceptedFiles } = useDropzone({ noClick: true });
  const { state } = useContext(Store);

  const [Title, setTitle] = useState("");
  const [createuser, setCreateUser] = useState("");
  const [selectedKbn, setSelectedKbn] = useState("");
  const [kbnOn, setkbnOn] = useState(false);

  const [isedit, setIsEdit] = useState("");

  const [globalList, setGlobalList] = useState([]);
  const [selectedGlobalList, setSelectedGlobalList] = useState([]);
  const [iswebview, setIsWebview] = useState(false);
  const [issendflag, setIsSendFlag] = useState(null);

  const [iseditself, setIsEditSelf] = useState(false);
  const [iscomment, setIsComment] = useState(true);

  const [fileList, setFileList] = useState([]);

  const [filteredKbnOptions, setKbnOptions] = useState(kbnOptions);

  const handleAddFileClick = async (event) => {
    if (inputTemplateRef.current.files.length === 0) {
      // エクスプローラ開く
      await InputElRef.current.click();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  // InputTemplateRefに入れてるファイルを消す
  const delFilesInInputTemplateRef = () => {
    if (inputTemplateRef.current) {
      const dataTransfer = new DataTransfer();
      inputTemplateRef.current.files = dataTransfer.files;
      setInputTemplateRefFileNum(inputTemplateRef.current.files.length);
      setFileList([]);
    }
    if (InputElRef.current) {
      InputElRef.current.value = null;
    }
  };

  // InputTemplateRefにファイルを追加
  const addFilesInInputTemplateRef = (addFiles) => {
    let fileerr = false;
    // 追加する前にファイル数やサイズ確認
    if (inputTemplateRef.current && inputTemplateRef.current.files.length + addFiles.length > 5) {
      /* 添付ファイル数5を超えた場合 */
      setFileNumError(true);
      fileerr = true;
    } else {
      for (let i = 0; i < addFiles.length; i++) {
        if (addFiles[i].size > 20000000) {
          /* 1ファイル20Mを超えた場合 */
          setFileSizeError(true);
          fileerr = true;
        }
      }
    }
    if (!fileerr && addFiles.length !== 0) {
      // https://qiita.com/jkr_2255/items/1c30f7afefe6959506d2
      const dataTransfer = new DataTransfer();
      // すでにあるファイルたち
      [].forEach.call(inputTemplateRef.current.files, (file) => {
        dataTransfer.items.add(file);
      });
      // 追加
      // addFilesが[object FileList]
      if (toString.call(addFiles) === toString.call(inputTemplateRef.current.files)) {
        [].forEach.call(addFiles, (file) => {
          dataTransfer.items.add(file);
        });
      }
      // addFilesが[object Array]
      if (toString.call(addFiles) === toString.call([])) {
        addFiles.forEach((file) => {
          if (file && file.file instanceof File) {
            dataTransfer.items.add(file.file);
          }
        });
      }
      // FileListを上書き
      inputTemplateRef.current.files = dataTransfer.files;

      // ファイルリスト更新 // 追加
      const newFileList = Array.from(inputTemplateRef.current.files).map((file) => ({
        name: file.name,
        size: file.size,
        file: file,
      }));

      setFileList(newFileList);
    }
    setInputTemplateRefFileNum(inputTemplateRef.current.files.length);
  };

  // ファイルリストから削除
  const handleRemoveFile = (index) => {
    const files = Array.from(inputTemplateRef.current.files);
    const newFiles = files.filter((_, i) => i !== index); // filterで新しい配列を作成

    const dataTransfer = new DataTransfer();
    newFiles.forEach((file) => dataTransfer.items.add(file)); // 新しい配列からdataTransferを作成
    inputTemplateRef.current.files = dataTransfer.files;

    const newFileList = newFiles.map((file) => ({
      // 新しい配列からfileListを更新
      name: file.name,
      size: file.size,
      file: file,
    }));
    setFileList(newFileList);
    setInputTemplateRefFileNum(inputTemplateRef.current.files.length);
    if (InputElRef.current) {
      InputElRef.current.value = null;
    }
  };

  // ファイルボタンに紐付いてるのはこの要素（InputElRef）
  // InputTemplateRefに追加する
  const onInputElRefChange = (e) => {
    const files = e.target.files;
    addFilesInInputTemplateRef(files);
  };

  // ドロップファイルをInputTemplateRefに追加
  useEffect(() => {
    if (acceptedFiles.length > 0) {
      addFilesInInputTemplateRef(acceptedFiles);
    }
  }, [acceptedFiles]);

  // ファイル追加ボタン
  const handleAddFileMenuClick = () => {
    setAnchorEl(null);
    InputElRef.current.click();
  };

  // ファイル削除ボタン
  const handleDelFileMenuClick = () => {
    setAnchorEl(null);
    delFilesInInputTemplateRef();
  };

  // ファイルメニューを閉じる
  const handleFileMenuClose = () => {
    setAnchorEl(null);
  };

  // ファイル追加エラー閉じる
  const handleFileErrorClose = () => {
    setFileNumError(false);
    setFileSizeError(false);
  };

  //編集時一覧をチェック
  const idset = (lists) => {
    if (lists && globalList.length > 0) {
      const idsArray = lists.split("_");
      const initialSelected = globalList.filter((option) => {
        return idsArray.includes(option.value);
      });

      setSelectedGlobalList(initialSelected);
    }
  };
  const mainproc = async () => {
    if (open == true) {
      if (!timelineid) {
        /* 新規作成の場合 */
        clearThumbnail();
        setTitle("");
        setCreateUser(state.user_name);
        setSelectedKbn("1");
        if (state.isadmin === "1" || state.isadmin === "6") {
          KbnChange("3"); //全員デフォルト表示が危険らしいので、施設を表示
          setkbnOn(true);
        } else if (state.isadmin === "2") {
          KbnChange("3"); //施設
          setkbnOn(true);
        } else if (state.isadmin === "3" || state.isadmin === "5") {
          KbnChange("2"); //グループ
          setkbnOn(true);
        } else if (state.isadmin === "4" || state.isadmin === "0") {
          KbnChange("5"); //個人
          setkbnOn(true);
        }

        setIsEditSelf(false);
        setIsEdit("");
        setIsWebview(false);
        setIsComment(true);
        setInputtext({ html: "本文を入力してください..." });
        setCharSize(0);
        setIsPlaceholder(true);
      } else {
        /* 既存データがある場合 */
        if (fileno == 1) {
          await getThumbnail(API_URL + `/GetTimelineThumbnail?timelineid=${timelineid}`);
        } else {
          clearThumbnail();
        }
        setTitle(title);
        setCreateUser(name);
        setkbnOn(false);
        setSelectedKbn(kbn);

        if ((state.honbuid == edithonbuid || state.isadmin === "1" || state.isadmin === "6") && kbn != "1") {
          KbnChange(kbn); //全員以外、ここで区分一覧取得
        } else {
          setGlobalList([]);
          setSelectedGlobalList([]);
        }

        FileListGet();

        setIsEditSelf(state.honbuid == edithonbuid || state.isadmin === "1" || state.isadmin === "6" ? false : true);
        setIsEdit(sendflagcheck);
        setIsWebview(iswebcheck === "1" ? true : false);
        setIsComment(iscommentcheck === "1" ? true : false);
        const htmlMessage = message.replace(/\r?\n/g, "<br>");
        setInputtext({ html: htmlMessage });
        const plainText = htmlMessage.replace(/<br>/g, "\n").replace(/<(?:.|)*?>/gm, "");
        setCharSize(plainText.length);
        setIsPlaceholder(false);
      }
    }
  };

  useEffect(() => {
    kbnOptioncheck();
    delFilesInInputTemplateRef(); //前回の添付ファイルを消す
    mainproc();
  }, [open]);

  //編集時一覧をチェック
  useEffect(() => {
    idset(ids);
    if (!timelineid && (state.isadmin === "1" || state.isadmin === "2" || state.isadmin === "6")) idset(state.hpcode);
  }, [globalList]);

  // 掲示板公開範囲権限
  const kbnOptioncheck = () => {
    let valuesToExclude;

    if (state.isadmin === "2") {
      valuesToExclude = ["1"];
      if (state.isbukaiadmin !== "1") {
        valuesToExclude.push("4");
      }
    } else if (state.isadmin === "3" || state.isadmin === "5") {
      valuesToExclude = ["1", "3"];
      if (state.isbukaiadmin !== "1") {
        valuesToExclude.push("4");
      }
    } else if (state.isadmin === "4" || state.isadmin === "0") {
      valuesToExclude = ["1", "2", "3"];
      if (state.isbukaiadmin !== "1") {
        valuesToExclude.push("4");
      }
    } else {
      setKbnOptions(kbnOptions);
      return;
    }

    const filteredKbnOptions = kbnOptions.filter((option) => !valuesToExclude.includes(option.value));
    setKbnOptions(filteredKbnOptions);
    setkbnOn(true);
  };

  // 掲示板公開範囲変更
  const KbnChange = async (timelinekbn) => {
    setSelectedKbn(timelinekbn);

    if (timelinekbn == "1") {
      setkbnOn(false);
      return;
    }

    let honbuid = localStorage.getItem("honbuid");

    const sql = `${API_URL}/GetTimelineKbnList?honbuid=${honbuid}&timeline_kbn=${timelinekbn}`;
    const result = await custom_axios(sql);

    const status = result.status;

    if (status === 401) {
      history.replace("/loginError");
    }
    if (status === 200) {
      const kbnlist = result.data.kbnlist.map((e) => {
        return { label: e.codename, value: e.code };
      });

      setSelectedGlobalList([]);
      setGlobalList(kbnlist);
      setkbnOn(true);
    }
    if (status === 204) {
      setSelectedGlobalList([]);
      setGlobalList([]);
      setkbnOn(true);
    }
  };

  // 添付ファイル一覧取得
  const FileListGet = async () => {
    const sql = `${API_URL}/GetTimelineFile?timelineid=${timelineid}`;
    const result = await custom_axios(sql);

    const status = result.status;
    if (status === 401) {
      history.replace("/loginError");
    }
    if (status === 200) {
      if (result.data && result.data.filelist) {
        const filelist = result.data.filelist;
        const fileDataList = filelist.map((file) => {
          const byteString = window.atob(file.fileBytes);
          const mimeType = file.mimetype;
          const content = new Uint8Array(byteString.length);
          for (let j = 0; j < byteString.length; j++) {
            content[j] = byteString.charCodeAt(j);
          }
          const blob = new File([content], file.filename, { type: mimeType });
          return {
            name: file.filename,
            size: blob.size,
            file: blob,
          };
        });
        setFileList(fileDataList);
        addFilesInInputTemplateRef(fileDataList);
      }
    }
  };

  // メッセージ送信
  const sendServer = async () => {
    /* ファイル送信について: PR121に詳細記載 */
    /* ドロップとボタンで追加されたファイルの準備 */
    // 送信する処理する前にクリアにする（テキストボックスに0.5秒ぐらい残り違和感）
    const messageNodes = [...myRef.current.childNodes];
    //console.log("myRef.current", myRef.current);
    const sendFiles = [];

    if (inputTemplateRef.current) {
      [].forEach.call(inputTemplateRef.current.files, (file) => {
        sendFiles.push(file);
      });
    }

    delFilesInInputTemplateRef();

    /* ペーストでの画像の準備 */
    // const sendPastedFiles = [];
    let sendMessage = "";
    for (let i = 0; i < messageNodes.length; i++) {
      const node = messageNodes[i];
      if (node.nodeName === "IMG") {
        // IMGを区切りにtextメッセージを送信する
        if (sendMessage !== "") {
          sendMessage = sendMessage.replace(/<br>/g, "\n");
          await sendText(sendMessage);
          sendMessage = "";
        }
        // Imageを送信する
        const byteString = window.atob(node.src.split(",")[1]);
        const mimeType = node.src.split(";")[0].split(":")[1];
        const content = new Uint8Array(byteString.length);
        for (let j = 0; j < byteString.length; j++) {
          content[j] = byteString.charCodeAt(j);
        }
        const blob = new File([content], "test", {
          type: mimeType,
        });
        // sendPastedFiles.push(blob);
        await sendImage(blob);
      } else if (node.nodeName === "#text") {
        sendMessage += node.data;
      } else if (node.nodeName === "FONT") {
        sendMessage += node.textContent;
      } else if (node.nodeName === "BR") {
        sendMessage += "<br>";
      } else {
        // IMG, #text, BR以外は何もしない
      }
    }

    if (sendMessage !== "") {
      sendMessage = sendMessage.replace(/<br>/g, "\n");
      if (timelineid == null) await sendText(sendMessage);
      else if (timelineid != null) await editText(sendMessage);
      sendMessage = "";
    }

    /* 添付ファイルでの画像送信 */
    if (sendFiles.length > 0) {
      for (let i = 0; i < sendFiles.length; i++) {
        if (timelineid == null) await sendImage(sendFiles[i]);
        else if (timelineid != null) await editImage(sendFiles[i]);
      }
    }

    setOpenCreateCommon(false);
    handleClose(); //登録ダイアログ閉じる
  };

  //掲示板概要送信
  const sendText = async (text) => {
    let targetlist = selectedGlobalList.length > 0 ? selectedGlobalList.map((e) => e.value).join("_") : "";

    /* テキスト送信 */
    if (text.trim() != "") {
      const params = new FormData();
      params.append("honbuid", state.honbuid);
      params.append("hpcode", state.hpcode);
      params.append("name", createuser);
      params.append("timeline_kbn", selectedKbn);
      params.append("title", Title);
      params.append("message", unescapeHTML(text.substring(0, 3000).trim()));
      params.append("messagetype", "message");
      params.append("iswebview", iswebview === true ? "1" : "0");
      params.append("iscomment", iscomment === true ? "1" : "0");
      params.append("ids", targetlist);
      params.append("sendflag", issendflag === 1 ? "" : issendflag === 2 ? "2" : "0");
      params.append("thumbnail", thumbnail);
      params.append("fileno", thumbnail === null ? "0" : "1");

      const result = await custom_axios_post(API_URL + "/InsertTimeline", params, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });

      const status = result.status;
      if (status === 401) {
        history.replace("/loginError");
      }
      if (status === 200) {
        // console.log("投稿成功");
      }
    }
  };

  //掲示板編集送信
  const editText = async (text) => {
    let targetlist = selectedGlobalList.length > 0 ? selectedGlobalList.map((e) => e.value).join("_") : "";

    /* テキスト送信 */
    if (text.trim() != "") {
      const params = new FormData();
      params.append("timelineid", timelineid);
      params.append("honbuid", state.honbuid);
      params.append("hpcode", state.hpcode);
      params.append("name", createuser);
      params.append("timeline_kbn", selectedKbn);
      params.append("title", Title);
      params.append("message", unescapeHTML(text.substring(0, 3000).trim()));
      params.append("messagetype", "message");
      params.append("iswebview", iswebview === true ? "1" : "0");
      params.append("iscomment", iscomment === true ? "1" : "0");
      params.append("ids", targetlist);
      params.append("sendflag", issendflag === 1 ? "" : issendflag === 2 ? "2" : "0");
      params.append("thumbnail", thumbnail);
      params.append("fileno", thumbnail === null ? "0" : "1");
      params.append("iseditself", iseditself ? "0" : "1");
      const result = await custom_axios_post(API_URL + "/EditTimeline", params, {
        headers: {
          "content-type": "multipart/form-data",
        },
      });

      const status = result.status;
      if (status === 401) {
        history.replace("/loginError");
      }
      if (status === 200) {
        // console.log("投稿編集成功");
      }
    }
  };

  const filetype = ["image/gif", "image/jpeg", "image/png", "image/bmp"];
  const videofiletype = ["video/mp4"];

  // 掲示板ファイル送信
  const sendImage = async (file) => {
    let sendURL = "";
    if (filetype.includes(file.type)) {
      sendURL = "/uploadTimelineImage";
    } else if (videofiletype.includes(file.type)) {
      sendURL = "/uploadTimelineVideo";
    } else {
      sendURL = "/uploadTimelineFile";
    }

    const params = new FormData();
    params.append("honbuid", localStorage.getItem("honbuid"));
    params.append("file", file);
    params.append("filename", file.name);
    params.append("mimetype", file.type);
    const result = await custom_axios_post(API_URL + sendURL, params, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    const status = result.status;
    if (status === 401) {
      history.replace("/loginError");
    }
    if (status === 200) {
      // console.log("ファイル", result);
    }
  };

  // 掲示板編集ファイル送信
  const editImage = async (file) => {
    let sendURL = "";
    if (filetype.includes(file.type)) {
      sendURL = "/editTimelineImage";
    } else if (videofiletype.includes(file.type)) {
      sendURL = "/editTimelineVideo";
    } else {
      sendURL = "/editTimelineFile";
    }

    const params = new FormData();
    params.append("timelineid", timelineid);
    params.append("honbuid", localStorage.getItem("honbuid"));
    params.append("file", file);
    params.append("filename", file.name);
    params.append("mimetype", file.type);
    const result = await custom_axios_post(API_URL + sendURL, params, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });

    const status = result.status;
    if (status === 401) {
      history.replace("/loginError");
    }
    if (status === 200) {
      // console.log("ファイル", result);
    }
  };

  const handleKeyDown = (e) => {
    //let checked = localStorage.getItem("checkedEnter") == "1" ? true : false;
    let checked = false;
    const sendMes = () => {
      e.preventDefault();
      sendServer();
    };
    // Enter押下
    if (e.which === 13) {
      // Ctrl
      if (e.ctrlKey && !e.shiftKey) {
        sendMes();
        // Shift
      } else if (!e.ctrlKey && e.shiftKey) {
        // 改行
        return false;
        // Ctrl, Shiftなし
      } else {
        // 「Enterで送信」チェックの有無
        if (checked) {
          sendMes();
        } else {
          // 改行
          return false;
        }
      }
    }
  };

  const [openCreateCommon, setOpenCreateCommon] = useState(false);
  const handleCreaeCommonClose = () => {
    setOpenCreateCommon(false);
  };

  const MemoCreateCommon = useMemo(() => {
    return (
      <ShowCommon
        open={openCreateCommon}
        handleClose={handleCreaeCommonClose}
        title={
          issendflag === 0 || (issendflag === 2 && isedit === "2")
            ? "一時保存しますか？"
            : issendflag === 2 && isedit === "1"
              ? "公開停止しますか？"
              : issendflag === 1 && isedit === "1"
                ? "編集しますか？"
                : issendflag === 1 && isedit === "2"
                  ? "公開再開しますか？"
                  : "投稿しますか？"
        }
        handleCallBack={sendServer}
      ></ShowCommon>
    );
  }, [openCreateCommon]);

  const [thumbnail, setThumbnail] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");

  //サムネイル画像を登録
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnail(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      clearThumbnail();
    }
  };

  //サムネイル画像を削除
  const clearThumbnail = () => {
    setThumbnail(null);
    // 以前の URL を取り消す
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl("");
  };
  //既に保存したサムネイル画像を取得
  const getThumbnail = async (url) => {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        // レスポンスがエラーの場合 (例: 404 Not Found, 500 Internal Server Error)
        clearThumbnail();
        return;
      }
      const blob = await response.blob();
      setThumbnail(blob);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      // fetch中にエラーが発生した場合
      clearThumbnail();
      return;
    }
  };

  const [previewOpen, setPreviewOpen] = useState({
    isopen: false,
    selectedTimeline: null,
  }); //プレビューページ

  //プレビューページへ遷移する
  const handlePreviewClick = async () => {
    await setPreviewOpen({
      isopen: true,
      selectedTimeline: [
        {
          title: Title,
          name: createuser,
          kbn: selectedKbn,
          kbnname: filteredKbnOptions.find((v) => v.value == selectedKbn).label,
          iswebview: iswebview === true ? "1" : "0",
          message: inputtext.html.trim().replace(/<br>/g, "\n"),
          thumbnail: previewUrl,
        },
      ],
    });
  };

  //プレビューページを閉じる
  const handleDetailClose = () => {
    setPreviewOpen({ isopen: false, selectedTimeline: null });
  };

  const MemoTimelinePreview = useMemo(() => {
    return (
      <ShowTimelinePreview
        open={previewOpen.isopen}
        timelineData={previewOpen.selectedTimeline}
        handleClose={() => handleDetailClose()}
      />
    );
  }, [previewOpen, handleDetailClose]);

  const inputCheck = () => {
    //#region 入力エラーチェック

    if (Title === "") {
      showSnackbar("タイトルを入力してください。");
      return false;
    }
    if (
      (!iswebview && (inputtext.html == "本文を入力してください..." || inputtext.html == "")) ||
      (!iswebview && isPlaceholder)
    ) {
      showSnackbar("本文を入力してください。");
      return false;
    }
    if (
      (iswebview && (inputtext.html == "URLを貼り付けてください..." || inputtext.html == "")) ||
      (iswebview && isPlaceholder)
    ) {
      showSnackbar("URLを貼り付けてください。");
      return false;
    }
    if (selectedKbn != "1" && selectedGlobalList.length == 0 && !iseditself) {
      showSnackbar("公開対象が未選択です。");
      return false;
    }
    return true;
    //#endregion
  };

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
      fullWidth
      maxWidth={"md"}
      // sx={{
      //   "& .MuiDialog-paper": {
      //     height: "90vh",
      //   },
      // }}
      TransitionComponent={Transition}
    >
      <StyledDialogTitle id="max-width-dialog-title">
        <div className="show-member-search">
          <StyledMarginDiv>ポスト作成</StyledMarginDiv>
          <div className="question-title-actions">
            <StyledButton onClick={() => handleClose()} variant="outlined">
              閉じる (Esc)
            </StyledButton>
          </div>
        </div>
      </StyledDialogTitle>

      <StyledDialogContent>
        {MemoTimelinePreview}
        {MemoCreateCommon}

        <Snackbar
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: "100%" }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <StyledFlexMainDiv>
          {/* 1 */}

          <StyledFlexTextDiv>
            <TextField
              label="タイトル(50文字)"
              variant="outlined"
              value={Title}
              onChange={(e) => setTitle(e.target.value)}
              margin="dense"
              size="small"
              inputProps={{
                maxLength: 50,
              }}
              style={{ width: "600px" }} // タイトルの幅を調整
            />

            <TextField
              label="表示名(20文字)"
              variant="outlined"
              value={createuser}
              onChange={(e) => setCreateUser(e.target.value)}
              margin="dense"
              size="small"
              inputProps={{
                maxLength: 20,
              }}
              style={{ width: "380px", marginLeft: "20px" }} // タイトルの幅を調整
            />
          </StyledFlexTextDiv>

          {/* 2 */}
          <StyledFlexTextDiv style={{ flexDirection: "column" }}>
            {previewUrl ? (
              <div
                className="thumbnail-preview"
                style={{ display: "flex", alignItems: "center", marginBottom: "10px", cursor: "pointer" }}
              >
                <img src={previewUrl} alt="プレビュー" style={{ maxWidth: "300px", maxHeight: "200px" }} />
              </div>
            ) : (
              <div style={{ width: "100%" }}>
                <div style={{ marginBottom: "5px" }}>サムネイル画像</div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "13px",
                    color: "#555555",
                    width: "100%",
                    height: "200px",
                  }}
                  {...getThumbnailDropProps({ className: "drop-zone-div-wraper" })} // Dropzoneの設定を適用
                >
                  <input {...getThumbnailInputProps()} /> {/* Dropzoneのinput */}
                  <CloudUploadIcon></CloudUploadIcon>
                  <div>クリックして画像を選択</div>
                  <div>または、この範囲に画像をドラッグ＆ドロップ</div>
                </div>
              </div>
            )}
            {/* 変更・クリアボタン類 */}
            {previewUrl && (
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Button component="label" variant="outlined" size="small">
                  サムネイル画像を変更
                  <input
                    accept="image/*"
                    type="file"
                    onChange={handleThumbnailChange}
                    style={{ display: "none" }}
                    key={thumbnail ? "change-" + thumbnail.name : "change-empty"} // 変更
                  />
                </Button>
                <Button variant="outlined" size="small" onClick={clearThumbnail}>
                  削除
                </Button>
              </div>
            )}
          </StyledFlexTextDiv>

          {/* 3 */}
          <div>
            {/* 公開範囲類 */}
            <StyledFlexTextDiv>
              <div>
                {!iseditself && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <FormControl variant="outlined" size="small" margin="dense" disabled={iseditself}>
                      <InputLabel htmlFor="select-kbn">公開範囲</InputLabel>
                      <Select
                        native
                        value={selectedKbn}
                        onChange={(e) => KbnChange(e.target.value)}
                        label="公開範囲"
                        inputProps={{
                          name: "kbn",
                          id: "select-kbn",
                        }}
                      >
                        {filteredKbnOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}

                {iseditself && (
                  <div style={{ color: "red", fontSize: "14px" }}>※公開範囲は、ポスト作成者のみ編集可能です</div>
                )}
              </div>
              {!iseditself && kbnOn && (
                <div
                  className="multi-select"
                  style={{
                    color: iseditself ? "#888" : "",
                  }}
                >
                  <MultiSelect
                    options={globalList}
                    value={selectedGlobalList}
                    onChange={(e) => {
                      setSelectedGlobalList(e);
                    }}
                    labelledBy={"Select"}
                    overrideStrings={{
                      selectSomeItems: "公開対象を選択",
                      allItemsAreSelected: "全選択",
                      selectAll: "全選択",
                      search: "検索",
                      clearSearch: "検索クリア",
                    }}
                    filterOptions={(options, filter) => {
                      if (!filter) {
                        return options;
                      }
                      const re = new RegExp(filter, "i");
                      return options.filter(({ label }) => label && label.match(re));
                    }}
                    disabled={iseditself}
                  />
                </div>
              )}
              <div style={{ marginLeft: "20px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={iswebview}
                      onChange={(e) => {
                        setIsWebview(e.target.checked);

                        delFilesInInputTemplateRef(); //添付ファイルを消す

                        if (!iswebview) setInputtext({ html: "URLを貼り付けてください..." });
                        else setInputtext({ html: "本文を入力してください..." });
                        setCharSize(0);
                        setIsPlaceholder(true);
                      }}
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label="外部サイトを埋め込む"
                />
                {/* <span>外部サイトを埋め込む</span> */}
              </div>
              <div style={{ marginLeft: "20px" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={iscomment}
                      onChange={(e) => {
                        setIsComment(e.target.checked);
                      }}
                      name="checkedB"
                      color="primary"
                    />
                  }
                  label="コメント機能の有効化"
                />
              </div>
            </StyledFlexTextDiv>

            {/* 本文入力欄 */}
            {fileSizeError || fileNumError ? (
              <div className="size-over-background">
                <div onClick={handleFileErrorClose} style={{ cursor: "pointer" }}>
                  {fileNumError && "1送信5ファイルまでです!! クリックで解除"}
                  {fileSizeError && "1ファイル20MBまでです!!  クリックで解除"}
                </div>
              </div>
            ) : issend == "1" ? (
              <div></div>
            ) : (
              <div
                {...getRootProps({ className: "message-box-wraper" })}
                style={
                  iswebview
                    ? { height: "auto", width: "98%", margin: "0 auto" }
                    : { height: "150px", width: "98%", margin: "0 auto" }
                }
              >
                <input {...getInputProps()} />
                <ContentEditable
                  translate="no"
                  onPaste={(e) => {
                    let imgs = [];
                    for (var i = 0; i < e.clipboardData.items.length; i++) {
                      // Skip content if not image
                      if (e.clipboardData.items[i].type.indexOf("image") == -1) continue;
                      // Retrieve image on clipboard as blob
                      var blob = e.clipboardData.items[i].getAsFile();
                      imgs.push(blob);
                    }
                    if (imgs.length > 0) {
                      /* 画像データ貼り付け時 */
                      //console.log("inputjs past元", blob);
                      //document.execCommand("insertHTML", false, e.clipboardData);
                    } else {
                      /* テキスト貼り付け時 */
                      e.preventDefault();
                      var text = e.clipboardData.getData("text/plain");
                      //console.log("inputjs past加工", text);
                      document.execCommand("insertHTML", false, text.replace(/\r?\n/g, "<br>"));
                    }
                  }}
                  className={"timelineeditablediv"}
                  innerRef={myRef}
                  html={inputtext.html}
                  disabled={false}
                  onFocus={() => {
                    if (isPlaceholder) {
                      setInputtext({ html: "" });
                      setIsPlaceholder(false);
                    }
                  }}
                  onBlur={() => {
                    if (inputtext.html === "" && myRef.current.innerHTML === "") {
                      if (iswebview) setInputtext({ html: "URLを貼り付けてください..." });
                      else setInputtext({ html: "本文を入力してください..." });
                      setCharSize(0);
                      setIsPlaceholder(true);
                    }
                  }}
                  onChange={(e) => {
                    let sendstr = myRef.current.innerHTML.replace(/<br>/g, "\n").replace(/<(?:.|)*?>/gm, "");
                    //console.log("文字の中身", myRef.current.innerHTML, sendstr);

                    setCharSize(sendstr.length);
                    setInputtext({ html: e.target.value });
                  }} // handle innerHTML change
                  onKeyDown={(e) => handleKeyDown(e)}
                />
              </div>
            )}

            {/* 添付＋文字数制限 */}
            {issend == "1" ? (
              <div></div>
            ) : (
              <div className="sending-area-buttom">
                {iswebview === false && (
                  <div style={{ display: "flex", alignItems: "flex-start", marginTop: "5px" }}>
                    <div className="reservation-area-buttons">
                      <IconButton color="primary" aria-label="send message" onClick={handleAddFileClick}>
                        <AttachFile />
                        <Badge
                          overlap="rectangular"
                          color="primary"
                          badgeContent={inputTemplateRefFileNum}
                          invisible={inputTemplateRefFileNum === 0}
                        ></Badge>
                      </IconButton>

                      <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleFileMenuClose}
                      >
                        <MenuItem onClick={handleAddFileMenuClick}>ファイル選択</MenuItem>
                        {inputTemplateRef.current !== null && inputTemplateRef.current.files.length > 0 && (
                          <MenuItem onClick={handleDelFileMenuClick}>ファイル削除</MenuItem>
                        )}
                      </Menu>
                      <input
                        key={fileList.length}
                        ref={InputElRef}
                        className="input-single-file"
                        id="icon-button-file"
                        type="file"
                        onChange={onInputElRefChange}
                        multiple="multiple"
                      />
                      <input
                        ref={inputTemplateRef}
                        className="input-single-file"
                        id="input-templete"
                        type="file"
                        multiple="multiple"
                      />
                    </div>
                    {fileList.length > 0 && (
                      <StyledFileList>
                        {fileList.map((file, index) => (
                          <StyledFileListItem key={index}>
                            <StyledFileLink href={URL.createObjectURL(file.file)} download={file.name}>
                              {file.name} ({Math.round(file.size / 1024)} KB)
                            </StyledFileLink>
                            <IconButton size="small" onClick={() => handleRemoveFile(index)}>
                              <DeleteIcon color="primary" />
                            </IconButton>
                          </StyledFileListItem>
                        ))}
                      </StyledFileList>
                    )}
                  </div>
                )}

                <div style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
                  文字: {charSize} / 3000
                </div>
              </div>
            )}
            {/* 投稿ボタン類 */}
            <StyledFlexDiv>
              {isedit === "1" || isedit == "2" ? (
                <Button
                  style={{ margin: "0 auto" }}
                  variant={isedit === "2" ? "outlined" : "contained"}
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    if (inputCheck()) {
                      setIsSendFlag(2);
                      setOpenCreateCommon(true);
                    }
                  }}
                  startIcon={<CancelScheduleSendIcon />}
                >
                  {isedit === "2" ? "一時保存" : "公開停止"}
                </Button>
              ) : (
                <Button
                  style={{ margin: "0 auto" }}
                  variant="outlined"
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    if (inputCheck()) {
                      setIsSendFlag(0);
                      setOpenCreateCommon(true);
                    }
                  }}
                  startIcon={<SendAndArchiveIcon />}
                >
                  一時保存
                </Button>
              )}
              <Button
                style={{ margin: "0 auto" }}
                variant="outlined"
                color="primary"
                onClick={handlePreviewClick}
                startIcon={<VisibilityOutlinedIcon />}
              >
                プレビュー
              </Button>
              <Button
                style={{ margin: "0 auto" }}
                variant="contained"
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  if (inputCheck()) {
                    setIsSendFlag(1);
                    setOpenCreateCommon(true);
                  }
                }}
                startIcon={<SendIcon />}
              >
                {isedit === "1" ? "編集" : isedit === "2" ? "公開再開" : "投稿"}
              </Button>
            </StyledFlexDiv>
          </div>
        </StyledFlexMainDiv>
      </StyledDialogContent>
    </Dialog>
  );
}

export default ShowTimelinePost;
